import { render, staticRenderFns } from "./client-field-edit-form.html?vue&type=template&id=4d27a0da&scoped=true&"
import script from "./client-field-edit-form.ts?vue&type=script&lang=js&"
export * from "./client-field-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d27a0da",
  null
  
)

export default component.exports